import {
  Email,
  Phone,
} from '@dapi/sdk';
import {
  createAddress,
  createEmail,
  createPhone,
  MockAddress,
  MockContact,
  MockEmail,
  MockPhone,
} from '@dapi/sdk/spec';

export const contactPhoneId = 'AP-10-PNR';
export const contactEmailId = 'AP-9-PNR';
export const contactAddressId = 'AP-11-PNR';
export const contactAnotherEmailId = 'AP-12-PNR';
export const contactAnotherPhoneId = 'AP-13-PNR';
const usCountryCode = 'US';

export const contactPhone: MockPhone = createPhone({
  template: {
    id: contactPhoneId,
    travelerIds: [],
    category: 'personal',
    contactType: 'Phone',
    deviceType: 'landline',
    purpose: 'standard',
    countryPhoneExtension: '358',
    number: '800120700'
  }
});

export const contactAnotherPhone: MockPhone = createPhone({
  template: {
    id: contactAnotherPhoneId,
    travelerIds: [],
    category: 'personal',
    contactType: 'Phone',
    deviceType: 'landline',
    purpose: 'standard',
    countryPhoneExtension: '91',
    number: '91919191911'
  }
});

export const contactEmail: MockEmail = createEmail({
  template: {
    id: contactEmailId,
    travelerIds: [],
    category: 'personal',
    contactType: 'Email',
    purpose: 'standard',
    address: 'laurent.martin.7w37fqht@mailosaur.io'
  }
});

export const contactAnotherEmail: MockEmail = createEmail({
  template: {
    id: contactAnotherEmailId,
    travelerIds: [],
    category: 'personal',
    contactType: 'Email',
    purpose: 'standard',
    address: 'anotheremail@abc.abc'
  }
});

export const contactAddress: MockAddress = createAddress({
  template: {
    id: contactAddressId,
    travelerIds: [],
    category: 'personal',
    lines: ['Test'],
    addresseeName: 'TEST',
    contactType: 'Address',
    purpose: 'billing',
    zipCode: '1234',
    countryCode: 'AS',
    cityName: 'TEST',
    stateCode: '00'
  }
});

export const address: MockAddress = createAddress({
  template: {
    countryCode: usCountryCode,
    lines: []
  }
});

export const standardContactPhone: MockPhone = {
  ...contactPhone,
  purpose: 'standard'
};

export const standardContactEmail: MockEmail = {
  ...contactEmail,
  purpose: 'standard'
};

export const contacts: MockContact[] = [contactPhone, contactEmail];
export const additionalcontacts: MockContact[] = [contactPhone, contactEmail, contactAnotherPhone, contactAnotherEmail];

export const email: Email = {
  id: 'email-id',
  address: 'christophe.bernard@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

export const phone: Phone = {
  id: 'phone-id',
  number: '+33123456789',
  category: 'personal',
  contactType: 'Phone',
  purpose: 'information'
};

export const multipleNotificationContacts = [{
  ...contactEmail,
  purpose: 'notification',
  travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
}, {
  ...contactPhone,
  purpose: 'notification'
},
{
  ...contactEmail,
  purpose: 'notification',
  travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
},
{
  ...contactEmail,
  purpose: 'notification',
  travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
},
{
  ...contactEmail,
  purpose: 'notification',
  travelerIds: ['JOURNEY-TRAVELER-2-MOCK']
},
{
  ...contactPhone,
  purpose: 'notification'
}];
